import { render, staticRenderFns } from "./CommonFormWithBranchEditor.vue?vue&type=template&id=3aab5c0c&lang=pug&"
import script from "./CommonFormWithBranchEditor.vue?vue&type=script&lang=ts&"
export * from "./CommonFormWithBranchEditor.vue?vue&type=script&lang=ts&"
import style0 from "./CommonFormWithBranchEditor.vue?vue&type=style&index=0&id=3aab5c0c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports